function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomMountainViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.83 10.83a2 2 0 00-3.186-.139l-5.873 7.1-1.542-1.275 5.874-7.1c1.69-2.043 4.865-1.905 6.373.277l5.347 7.739-1.646 1.136-5.347-7.739z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.373 15.848a2 2 0 00-3.202-.078l-5.385 6.848-1.572-1.236 5.385-6.848c1.651-2.1 4.856-2.022 6.404.155l2.812 3.954-1.63 1.159-2.812-3.954zM19.39 8.712c.079 0 .159 0 .238.083.398.164.797 0 .956-.411.319-.494.717-.74 1.195-.74.557 0 1.115.41 1.274.986.08.329.398.575.797.575.318 0 .557.247.557.576 0 .329-.239.575-.557.575h-4.46a.81.81 0 01-.797-.822c0-.493.319-.822.796-.822zm0 3.288h4.46c1.194 0 2.15-.986 2.15-2.22 0-.985-.637-1.89-1.593-2.136A2.949 2.949 0 0021.78 6c-.876 0-1.673.41-2.23 1.068h-.16C18.115 7.068 17 8.137 17 9.534 17 10.85 18.035 12 19.39 12z",
    fill: props.color
  }));
}

export default SvgIconRoomMountainViewFilled;